import { useCallback, useEffect, useState, useRef } from 'react';
import { Toast } from 'antd-mobile';
import { fixedBody, looseBody } from '@/utils/fn';
import { copyEvent, jsHandleShare } from '@/utils/bridge';
import CustomModal from '@/components/CustomModal';
import BScroll from '@better-scroll/core';
import {
  INVITE_MISSION_INFO,
  INVITE_MISSION_REWARD_TEXT,
  INVITE_STATUS_TEXT_MAP,
  INVITE_TASK_MODAL_INFO,
  INVITE_TASK_SHOW_MAX_REMAIND_DAY,
  INVITE_TASK_SPECTIAL_REMAIND_DAY,
  INVITE_TASK_STATUS_TEXT_MAP,
  INVITE_TASK_TO_BE_COMPLETED_STATUS,
  SHARE_TASK_TEXT,
} from '../config';
import styles from '../styles/common.less';

const InviteMissionModal = ({
  visible,
  handleClose,
  missionInfo: { inviteStatus, taskList },
  phone,
}) => {
  const bsScrollRef = useRef(null);
  const [modalInfo, setModalInfo] = useState({ visible: false, taskId: '' });

  const handleOpenModal = useCallback(taskId => {
    setModalInfo({
      taskId,
      visible: true,
    });
  }, []);

  const handleRemindFriend = useCallback(() => {
    copyEvent({ text: SHARE_TASK_TEXT });
    jsHandleShare(
      {
        share_item: {
          platform: 0,
          type: 0,
          share_content: SHARE_TASK_TEXT,
        },
      },
      res => {
        if (res.code !== 0) {
          Toast.info('已复制到剪贴板，请前往提醒');
        }
      }
    );
  }, []);

  useEffect(() => {
    if (visible) {
      fixedBody();
    } else {
      looseBody();
    }
  }, [visible]);

  useEffect(() => {
    let bsScroll;
    if (taskList?.length && bsScrollRef.current) {
      bsScroll = new BScroll(bsScrollRef.current, {
        click: true,
        tab: true,
      });
    }
    return () => bsScroll?.destroy();
  }, [taskList]);

  return (
    <div className={`${styles.modal} ${visible ? styles.show : styles.hide}`}>
      <div
        className={`${styles.modalContent} ${styles.missionContent}`}
        onClick={e => e.stopPropagation()}
      >
        <i
          className={`${styles['afont']} ${styles['icon-close']} ${styles.closeIcon}`}
          onClick={handleClose}
        />
        <div className={`${styles.modalBody}`}>
          <h4 className={styles.phone}>{phone}</h4>
          <h3 className={styles.inviteStatus}>{INVITE_STATUS_TEXT_MAP[inviteStatus]}</h3>
          <div className={styles.rewardText}>
            {INVITE_MISSION_REWARD_TEXT[inviteStatus]?.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
          <div className={styles.scrollContent} ref={bsScrollRef}>
            <div style={{ transform: visible ? '' : 'translateY(0)' }}>
              <div className={styles.missionList}>
                {taskList?.map((item, index) => {
                  const { taskStatus, taskId, remainDays } = item;
                  const taskInfo = INVITE_MISSION_INFO[taskId] || {};
                  const { taskName, taskReward } = taskInfo;
                  const isTaskUncompleted = taskStatus === INVITE_TASK_TO_BE_COMPLETED_STATUS;
                  let showTag = !isTaskUncompleted;
                  if (isTaskUncompleted) {
                    // 如果是第一个待完成任务也展示角标
                    const firstIndex = taskList.findIndex(
                      item => item.taskStatus === INVITE_TASK_TO_BE_COMPLETED_STATUS
                    );
                    showTag = firstIndex === index;
                  }
                  return (
                    <div
                      className={`${styles.missionItem} ${styles[`status-${taskStatus}`]} ${
                        styles[`task-${taskId}`]
                      } ${remainDays <= INVITE_TASK_SHOW_MAX_REMAIND_DAY ? styles.rest : ''}`}
                      key={index}
                    >
                      {showTag && (
                        <p className={styles.tag}>
                          {isTaskUncompleted && remainDays <= INVITE_TASK_SHOW_MAX_REMAIND_DAY
                            ? remainDays > INVITE_TASK_SPECTIAL_REMAIND_DAY
                              ? `最后${remainDays}天`
                              : '即将过期'
                            : INVITE_TASK_STATUS_TEXT_MAP[taskStatus]}
                        </p>
                      )}
                      {INVITE_TASK_MODAL_INFO[taskId] ? (
                        <i className={styles.qa} onClick={() => handleOpenModal(taskId)} />
                      ) : null}
                      <p className={styles.missionName}>{taskName}</p>
                      <div className={`${styles.reward}`}>
                        {taskReward?.map((rewardItem, index) => (
                          <p className={styles.bonus} key={index}>
                            {rewardItem.flag}
                            {rewardItem.reward && <em>{rewardItem.reward}</em>}
                            {rewardItem.text}
                          </p>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button onClick={handleRemindFriend}>点击提醒TA</button>
        </div>
      </div>
      <CustomModal
        title={INVITE_TASK_MODAL_INFO[modalInfo.taskId]?.title}
        visible={modalInfo.visible}
        okText="我知道了"
        okCallback={() => setModalInfo({ visible: false })}
        needFixedBody={false}
      >
        {INVITE_TASK_MODAL_INFO[modalInfo.taskId]?.content?.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </CustomModal>
    </div>
  );
};
export default InviteMissionModal;
